import $ from 'jquery';
import AOS from 'aos';

$(document).ready(function() {
  AOS.init({});
});